import type { ProductGroup, ProductGroupFormState } from '@@partner:types:app'

import { mergeLeft, mergeLeftDropping } from 'merge-left-utils'

export const PRODUCT_GROUP_DEFAULT_STATE: ProductGroupFormState = {
  id: undefined,
  name: '',
  label: '',
  type: 'custom',
  story_id: undefined,
  i18n: [],
  languages: []
}

export const makeProductGroupFormState = (productGroup?: ProductGroup): ProductGroupFormState => {
  const state = {
    ...productGroup,
    languages: productGroup?.i18n?.map((i18n) => i18n.language_code) || []
  }
  return mergeLeft<ProductGroupFormState>(PRODUCT_GROUP_DEFAULT_STATE, state)
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (state: ProductGroupFormState): any =>
  mergeLeftDropping([ 'languages' ], PRODUCT_GROUP_DEFAULT_STATE, {
    ...state
  })

export const mapApiDataToState = (data: ProductGroup) => makeProductGroupFormState(data)
